var map = {
	"./abacus-icon.svg": [
		"b200",
		"chunk-26a9510a"
	],
	"./abacus.svg": [
		"8a36",
		"chunk-54b823bf"
	],
	"./actions.svg": [
		"6663",
		"chunk-52f0e42e"
	],
	"./address-book-o.svg": [
		"01ea",
		"chunk-52979164"
	],
	"./admission.svg": [
		"3598b",
		"chunk-3c5c6f54"
	],
	"./angle-down.svg": [
		"5fb7",
		"chunk-574a70a5"
	],
	"./angle-left.svg": [
		"abd5",
		"chunk-cc28d2ce"
	],
	"./angle-right.svg": [
		"782e",
		"chunk-38b10ef7"
	],
	"./angle-up.svg": [
		"069b",
		"chunk-6f867dc8"
	],
	"./angle.svg": [
		"f035",
		"chunk-1535a69f"
	],
	"./arithmetic.svg": [
		"5dcb",
		"chunk-05ceb4dd"
	],
	"./bell.svg": [
		"673b",
		"chunk-6c53247b"
	],
	"./book.svg": [
		"bd9b",
		"chunk-68107f60"
	],
	"./calendar-check-o.svg": [
		"88f7",
		"chunk-3d3a9a9a"
	],
	"./calendar-list.svg": [
		"a77c",
		"chunk-291f8f49"
	],
	"./calendar-o.svg": [
		"910f",
		"chunk-21fa14fd"
	],
	"./calendar.svg": [
		"00f3",
		"chunk-553a591e"
	],
	"./cancel.svg": [
		"89bc",
		"chunk-1c9815c9"
	],
	"./check-answers.svg": [
		"a92b",
		"chunk-22a42fba"
	],
	"./check.svg": [
		"8525",
		"chunk-4369598b"
	],
	"./circle-check.svg": [
		"8eb0",
		"chunk-bf76b720"
	],
	"./circle-close.svg": [
		"d3b1",
		"chunk-587c64a6"
	],
	"./circle-down.svg": [
		"7375",
		"chunk-303c8dde"
	],
	"./circle-up.svg": [
		"273d",
		"chunk-1eab19b5"
	],
	"./clock-o.svg": [
		"a174",
		"chunk-69a4bcde"
	],
	"./close-menu.svg": [
		"f17e",
		"chunk-bacf435c"
	],
	"./close.svg": [
		"9d4a",
		"chunk-c232915a"
	],
	"./cloud.svg": [
		"c004",
		"chunk-8ffe618c"
	],
	"./cog.svg": [
		"c8ed",
		"chunk-3c9d1877"
	],
	"./coin.svg": [
		"2949",
		"chunk-4c196802"
	],
	"./edit.svg": [
		"cd88",
		"chunk-7fc3290a"
	],
	"./envelope-open.svg": [
		"44c5",
		"chunk-aaf06fce"
	],
	"./envelope.svg": [
		"0d6a",
		"chunk-5b697268"
	],
	"./exclamation-circle.svg": [
		"210c",
		"chunk-0efc8219"
	],
	"./exclamation-mark.svg": [
		"7fea",
		"chunk-66318a80"
	],
	"./explore.svg": [
		"3b1a",
		"chunk-9251dc68"
	],
	"./female.svg": [
		"cb1b",
		"chunk-f53e8aca"
	],
	"./flag.svg": [
		"11a3",
		"chunk-48e0ccb9"
	],
	"./folder.svg": [
		"9924",
		"chunk-757da369"
	],
	"./gear.svg": [
		"6965",
		"chunk-e403c7ee"
	],
	"./geolocalization.svg": [
		"dc1d",
		"chunk-f61ff08e"
	],
	"./gift.svg": [
		"9464",
		"chunk-41b0b012"
	],
	"./goal.svg": [
		"b337",
		"chunk-019dbb14"
	],
	"./infinity.svg": [
		"5239",
		"chunk-ea9bb8b0"
	],
	"./list-inverse.svg": [
		"b3e4",
		"chunk-4f0a2b4b"
	],
	"./list.svg": [
		"e68e",
		"chunk-4aa00aed"
	],
	"./loader.svg": [
		"e046",
		"chunk-90e76904"
	],
	"./lock.svg": [
		"b7d0",
		"chunk-9a557dec"
	],
	"./login.svg": [
		"28a4",
		"chunk-93fb631c"
	],
	"./logout.svg": [
		"343a",
		"chunk-762d783c"
	],
	"./male.svg": [
		"7579",
		"chunk-8311156a"
	],
	"./minus.svg": [
		"e78d",
		"chunk-9e6741a6"
	],
	"./money.svg": [
		"a20a",
		"chunk-a7f7422e"
	],
	"./open-menu.svg": [
		"098c",
		"chunk-66a235d2"
	],
	"./paper.svg": [
		"b1b3",
		"chunk-423f71aa"
	],
	"./paperclip.svg": [
		"65d0",
		"chunk-674fd320"
	],
	"./pause.svg": [
		"1525",
		"chunk-358a5084"
	],
	"./phone.svg": [
		"6e21",
		"chunk-e374fa46"
	],
	"./pin.svg": [
		"ab41",
		"chunk-b025d026"
	],
	"./plane.svg": [
		"0719",
		"chunk-42f5627c"
	],
	"./play-button.svg": [
		"c6da",
		"chunk-32d5f99b"
	],
	"./play.svg": [
		"6c69",
		"chunk-c07a49ca"
	],
	"./plus.svg": [
		"9e7b",
		"chunk-b1a122d8"
	],
	"./pointer.svg": [
		"23a1",
		"chunk-ad04378c"
	],
	"./profile.svg": [
		"0fbd",
		"chunk-82834cda"
	],
	"./refresh-game.svg": [
		"2f61",
		"chunk-78ade0bc"
	],
	"./reload.svg": [
		"dcb1",
		"chunk-4dfa377d"
	],
	"./reward.svg": [
		"090a",
		"chunk-221359d1"
	],
	"./search.svg": [
		"e408",
		"chunk-f23c7998"
	],
	"./select.svg": [
		"710a",
		"chunk-1e2e0840"
	],
	"./small-angle-down.svg": [
		"c9e8",
		"chunk-59690a02"
	],
	"./small-angle-left.svg": [
		"8f88",
		"chunk-6806dd9d"
	],
	"./small-angle-right.svg": [
		"e0c7",
		"chunk-6f86050c"
	],
	"./small-angle-up.svg": [
		"76e9",
		"chunk-b0917050"
	],
	"./sound-off.svg": [
		"1004",
		"chunk-7ab9bdf0"
	],
	"./sound-on.svg": [
		"b9d8",
		"chunk-df834080"
	],
	"./spin.svg": [
		"f16a",
		"chunk-66dec095"
	],
	"./star-checked.svg": [
		"efd1",
		"chunk-f8a2b8c6"
	],
	"./star-fill.svg": [
		"7e64",
		"chunk-097d2e82"
	],
	"./star.svg": [
		"0995",
		"chunk-99d39874"
	],
	"./student.svg": [
		"cded",
		"chunk-1750cecb"
	],
	"./tablet.svg": [
		"9fcc",
		"chunk-2857a33e"
	],
	"./times.svg": [
		"3efa",
		"chunk-3bb64644"
	],
	"./trash.svg": [
		"0d07",
		"chunk-4d3a5930"
	],
	"./trophy-bronze.svg": [
		"a7f4",
		"chunk-e19ea9f2"
	],
	"./trophy-gold-plus.svg": [
		"cba5",
		"chunk-23c1c2d8"
	],
	"./trophy-gold.svg": [
		"6772",
		"chunk-23f918a2"
	],
	"./trophy-silver.svg": [
		"b2e9",
		"chunk-209d8cf2"
	],
	"./university.svg": [
		"1a5e",
		"chunk-00d9566b"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "153d";
module.exports = webpackAsyncContext;